import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [
  { title: "menu_sidebar_management" },
  { title: "menu_sidebar_management_list_management" },
  { title: "menu_sidebar_management_service" },
  { title: "menu_sidebar_management_service_discount_center" }
];
const LabManagementListing = Loadable({
  loader: () => import("container/management/labs"),
  loading() {
    return <Loader />;
  }
});

export const discountRoutes: IRoute[] = [
  {
    path: "/management/discount-center",
    element: <LabManagementListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  }
];
